import Script from "next/script";
import settings from "src/settings";
import { breakpoints, media } from "src/styles/styleUtils";
import styled from "styled-components";
const { GAME_UID } = settings;

const NavContainer = styled.div`
  width: 100%;

  .navbar-mobile-container .logo {
    :after {
      display: none;
    }
    ${media.mobile} {
      margin-left: calc(50% - 66px);
    }
  }

  .mobile-tickets {
    ${media.mobile} {
      display: none;
    }
  }

  .inner-navbar-container {
    max-width: ${breakpoints.contentMaxWidth} !important;
  }

  .mobileSideNavInner {
    max-width: ${breakpoints.contentMaxWidth};
  }
`;

function NascarNav() {
  return (
    <>
      <Script
        id={`${GAME_UID}-jQuery`}
        key={`${GAME_UID}-jQuery`}
        src="https://unpkg.com/jquery@3.3.1/dist/jquery.min.js"
        crossOrigin="anonymous"
        strategy="beforeInteractive"
      />
      <Script
        id={`${GAME_UID}-nascar-nav`}
        key={`${GAME_UID}-nascar-nav`}
        type="text/javascript"
        src="https://www.nascar.com/wp-content/themes/ndms-2023/inc/nav/thirdPartyNavigationBar.js?v=1.8570"
        show-login="false"
        show-search="false"
        show-header="false"
        show-footer="true"
        show-alertbar="false"
        show-profile="false"
        show-rewards="false"
        show-trending="false"
        show-top-nav="true"
        show-series="false"
        nav-root-id="nascarNav"
        strategy="afterInteractive"
      />

      <NavContainer id="nascarNav" />
    </>
  );
}
export default NascarNav;
